import React, { useCallback } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../redux/reducers/Alerts";
import "survey-core/survey.css";
import { closeSurvey } from "../../../redux/reducers/Survey";
import { saveSurveyResults } from "src/docuclipper/api";

const surveyJson = {
  "title": null,
  "completedHtml": "Thank you for sharing your feedback with us!",
  "pages": [
    {
      "elements": [
        {
          "type": "rating",
          "name": "satisfaction",
          "title": "How satisfied are you with our website?",
          "isRequired": true,
          "rateMin": 1,
          "rateMax": 5,
          "rateStep": 1
        },
        {
          "type": "comment",
          "name": "comment",
          "title": "What can we do to improve your experience?",
          "isRequired": true,
          "rows": 3
        }
      ]
    }
  ],
  "showQuestionNumbers": "off",
  "completeText": "Send Feedback"
}

export const SurveyFeedback: React.FC = () => {
  const dispatch = useDispatch();
  const survey = new Model(surveyJson);
  const surveyComplete = useCallback((sender) => {
    saveSurveyResults("feedback", sender.data)
      .then(() => {
        dispatch(closeSurvey());
      })
      .catch((err) => {
        dispatch(
          createAlert({
            message: "Error sending survey",
            timeout: 0,
            type: "error",
          })
        );
        dispatch(closeSurvey());
      });
  }, []);

  survey.onComplete.add(surveyComplete);

  return (
    <>
      <Survey model={survey} />
    </>
  );
};
export default SurveyFeedback;
